/**
 * CSV the way Excel on a Thai Windows desktop opens it correctly: UTF-8 with a byte-order
 * mark (without it Excel guesses the ANSI code page and Thai turns to mojibake), CRLF line
 * ends, and RFC 4180 quoting — a field is quoted when it holds a comma, a double quote, CR
 * or LF, and a double quote inside it is doubled.
 */

export const BOM = '﻿';

export type CsvCell = string | number | null | undefined;

/**
 * A text cell that Excel would run as a formula (`=`, `+`, `-`, `@`, tab, CR first) gets a leading
 * `'` (OWASP CSV injection) — unless it is just a number such as "-1,250.00". The BFF's Master
 * export does the same.
 */
function defused(s: string): string {
  return /^[=+\-@\t\r]/.test(s) && !/^[+-]?\d[\d,]*(\.\d+)?$/.test(s) ? `'${s}` : s;
}

export function csvField(v: CsvCell): string {
  if (v === null || v === undefined) return '';
  const s = typeof v === 'number' ? (Number.isFinite(v) ? String(v) : '') : defused(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(header: readonly string[], rows: readonly (readonly CsvCell[])[]): string {
  const lines = [header, ...rows].map((r) => r.map(csvField).join(','));
  return `${BOM}${lines.join('\r\n')}\r\n`;
}

/** Hand a text file to the browser: Blob + a temporary `<a download>`, revoked one tick later. */
export function downloadText(name: string, text: string, type = 'text/csv;charset=utf-8'): void {
  downloadBlob(name, new Blob([text], { type }));
}

/** Hand a file the server wrote (bytes as they came, BOM included) to the browser. */
export function downloadBlob(name: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoked on the next tick: some browsers cancel a download whose URL is revoked synchronously.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
